
import { takeEvery } from 'redux-saga/effects'

import {
    createActionTypes,
} from '../common/client/sagas/common';

import { workGetArticles } from './common/articles';

export const GET_ARTICLES_ACTION_TYPE = createActionTypes('articles/GET_ARTICLES');

export default function getActions(dispatch) {
    return {
        getArticles: () => dispatch({
            type: GET_ARTICLES_ACTION_TYPE.DEFAULT
        }),
    };
}

export function* watchGetArticles(options) {
    yield takeEvery(
        GET_ARTICLES_ACTION_TYPE.DEFAULT, workGetArticles, options, GET_ARTICLES_ACTION_TYPE
    );
}
